var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 8C8.73622 8 9.33317 8.59695 9.33317 9.33333V20.2667C9.33317 21.4088 9.33421 22.1852 9.38324 22.7853C9.431 23.3698 9.51757 23.6688 9.62382 23.8773C9.87948 24.3791 10.2874 24.787 10.7892 25.0427C10.9977 25.1489 11.2967 25.2355 11.8812 25.2833C12.4813 25.3323 13.2577 25.3333 14.3998 25.3333H17.5998C18.7419 25.3333 19.5183 25.3323 20.1185 25.2833C20.703 25.2355 21.0019 25.1489 21.2105 25.0427C21.7122 24.787 22.1202 24.3791 22.3759 23.8773C22.4821 23.6688 22.5687 23.3698 22.6164 22.7853C22.6655 22.1852 22.6665 21.4088 22.6665 20.2667V9.33333C22.6665 8.59695 23.2635 8 23.9998 8C24.7362 8 25.3332 8.59695 25.3332 9.33333V20.3217C25.3332 21.395 25.3332 22.2808 25.2742 23.0024C25.213 23.7519 25.0816 24.4408 24.7519 25.0879C24.2405 26.0915 23.4247 26.9074 22.4211 27.4187C21.774 27.7484 21.0851 27.8798 20.3356 27.9411C19.614 28 18.7282 28 17.6549 28H14.3448C13.2715 28 12.3857 28 11.6641 27.9411C10.9146 27.8798 10.2257 27.7484 9.57856 27.4187C8.57502 26.9074 7.75913 26.0915 7.2478 25.0879C6.91808 24.4408 6.78666 23.7519 6.72543 23.0024C6.66647 22.2808 6.66649 21.395 6.6665 20.3217L6.66651 9.33333C6.66651 8.59695 7.26346 8 7.99984 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C15.2636 20 14.6667 20.597 14.6667 21.3333V25.3333H12V21.3333C12 19.1242 13.7909 17.3333 16 17.3333C18.2091 17.3333 20 19.1242 20 21.3333V25.3333H17.3333V21.3333C17.3333 20.597 16.7364 20 16 20Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14057 11.263C4.46989 11.9216 5.27078 12.1886 5.92942 11.8592L15.9998 6.82406L26.0702 11.8592C26.7288 12.1886 27.5297 11.9216 27.859 11.263C28.1884 10.6043 27.9214 9.80343 27.2628 9.47411L16.5961 4.14078C16.2207 3.95309 15.7789 3.95309 15.4035 4.14078L4.73685 9.47411C4.07821 9.80343 3.81125 10.6043 4.14057 11.263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.a0666033.svg";
export { ForwardRef as ReactComponent };